<template>
  <div>
    <v-row v-if="item != undefined" justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <div class="mod-custom">
          <div class="clse">
            <v-btn icon @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-container>
              <v-row class="custom">
                <v-col md="12">
                  <div class="md-tl">
                    <p>Bloquear</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <p>
                    Se bloqueara el acceso a: <b>{{ item.name }}</b>
                  </p>
                  <v-select
                    ref="block"
                    class="select-lock"
                    v-model="item.block"
                    :items="[true, false]"
                    label="Acceso actual"
                    return-object
                  >
                    <template slot="selection" slot-scope="{ item }">
                      <v-icon class="open-i" v-if="item == true"
                        >mdi-lock</v-icon
                      >
                      <v-icon class="close-i" v-if="item == false"
                        >mdi-lock-open</v-icon
                      >
                      {{ item == true ? "Bloqueado" : "Desbloqueado" }}
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      <v-icon class="open-i" v-if="item == true"
                        >mdi-lock</v-icon
                      >
                      <v-icon class="close-i" v-if="item == false"
                        >mdi-lock-open</v-icon
                      >
                      {{ item == true ? "Bloqueado" : "Desbloqueado" }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >Actualizar</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FolderLock",
  components: {},
  props: ["visible", "item"],
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
      }
    });
  },
  updated() {},
  watch: {},
  methods: {
    ...mapActions(["lockFolderUpdate"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.updateSendLock();
        console.log("lockFolderUpdate");
      }
    },
    async updateSendLock() {
      try {
        let frSend = {
          _id: this.item._id,
          block: this.item.block,
        };
        let responsed = await this.lockFolderUpdate(frSend);
        if (responsed == 200) {
          this.$refs.form.reset();
          //console.log("creado", responsed);
          this.$root.$emit("reload");
          this.$root.$emit("snackbar", {
            status: 200,
            visible: true,
            text: `La carpeta se ha bloqueado.`,
          });
          this.show = false; // parametro update tabla
        }
      } catch (error) {
        this.$refs.form.reset();
        //console.log("error catch", error);
        this.$root.$emit("snackbar", {
          status: 404,
          visible: true,
          text: `Ocurrió un error inesperado - ${error}`,
        });
        this.show = false;
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
